import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import AuthService from '../../services/auth'
import BusinessNavbar from '../../components/Navbars/BusinessNavbar'
import ItemTabs from '../../components/ItemTabs'
import CashRegisters from './CashRegisters'
import CashRegisterHistory from './CashRegisterHistory'
import OpenBills from './OpenBills'
import ClosedBills from './ClosedBills'
import Comissions from './Comissions'
import Dre from './Dre'
import CashFlow from './CashFlow'
import { Container, TabStickyContainer, Title } from './styles'

export default function Financial () {
  const location = useLocation ()
  const financialTab = location.state?.financialTab ?? null

  const handleTabNavigate = tabValue => {
    setSelectedTab (tabValue)
    localStorage.setItem ('financial_option', tabValue)
  }

  const TAB_LIST = [
    {label: 'Caixas abertos', value: 'cash_registers', component: <CashRegisters onTabNavigate={handleTabNavigate}/>},
    {label: 'Histórico de caixa', value: 'cash_register_history', component: <CashRegisterHistory/>},
    {label: 'Comandas abertas', value: 'open_bills', component: <OpenBills/>},
    {label: 'Comandas fechadas', value: 'closed_bills', component: <ClosedBills/>},
    {label: 'Comissões', value: 'comissions', component: <Comissions/>},
    {label: 'DRE', value: 'dre', component: <Dre/>},
    {label: 'Fluxo de caixa', value: 'cash_flow', component: <CashFlow/>},
  ].filter (tab => AuthService.hasPermission (`financial.${tab.value}`))

  const [selectedTab, setSelectedTab] = useState (
    financialTab ?? localStorage.getItem ('financial_option') ?? TAB_LIST[0].value
  )

  return (
    <Container>
      <BusinessNavbar/>
      <Title>Financeiro</Title>
      <TabStickyContainer>
        <ItemTabs
          tabs={TAB_LIST}
          tabWidth={160}
          selectedTab={selectedTab}
          onTabChange={handleTabNavigate}
          containerStyle={{paddingBottom: 7}}
        />
      </TabStickyContainer>
      {TAB_LIST.find (tab => tab.value === selectedTab).component}
    </Container>
  )
}
